/**
 * List Schema of EmailDestinatario
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {EmailDestinatario} from '@/model/resource/EmailDestinatario'

/* TODO: review generated schema */
export class ListEmailDestinatarioSchema extends Schema {
  readonly name = 'ListEmailDestinatario'

  readonly fieldSet: FieldSet<EmailDestinatario> = {
    idEmailDestinatarioPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    cpfCnpj: (): FieldComponent => ({
      is: Component.Render,
    }),
    email: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
